import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Futbol amerykański",
    Baseball: "Baseball",
    Basketball: "Koszykówka",
    Boxing: "Boks",
    Chess: "Szachy",
    Cricket: "Krykiet",
    Darts: "Dart",
    Entertainment: "Rozrywka",
    "E-Sports": "E-Sports",
    Football: "Futbol ",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Futbol gaelicki",
    "Generic Sport": "Sporty Ogólne",
    Golf: "Golf",
    "Greyhound Racing": "Wyścigi chartów",
    Handball: "Piłka Ręczna",
    "Ice Hockey": "Hokej na Lodzie",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Polityka",
    "Rugby League": "Rugby Liga",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tenis stołowy",
    Tennis: "Tenis ziemny",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} wygra",
    WinFirstRound: "{name} wygra pierwszą rundę",
    FirstTouchdown: "{name} zdobędzie touchdown jako pierwszy",
    FirstTry: "{name} zdobędzie try jako pierwszy",
    TotalGoals: "{name} suma goli",
    TotalRuns: "{name} suma runów",
    TotalPoints: "{name} suma punktów",
    TopBatsman: "{name} zostanie najlepszym odbijającym",
    TopBowler: "{name} zostanie najlepszym rzucającym",
    FirstScore: "{name} zdobędzie gola jako pierwszy"
  },
  PromoTexts: {
    Pick: "Wybierz swoje zakłady",
    Bet: "Zakład",
    Pays: "Wypłata"
  },
  DateTimeTexts: {
    Today: "Dzisiaj",
    Tomorrow: "Jutro",
    Live: "Na żywo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Wybierz swoje zakłady",
    Return: "Wypłata",
    Stake: "Zakład",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "na mecz",
    H2H: "H2H",
    W: "Z",
    D: "R",
    L: "P",
    T: "R",

    // soccer
    goals_scored: "Gole strzelone",
    shots: "Strzały",
    shots_on_target: "Strzały celne",
    ball_possession: "Posiadanie piłki",
    goals_conceded: "Gole stracone",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
